// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__G5i4Y","show":"style_show__cg4eJ","icon":"style_icon__HPtCa","wallet":"style_wallet__BPH5V"};